/**
 * 人员KPI服务
 */

import axios from 'axios';
import { MemberKPITarget, MemberPerformanceRecord, MemberSummary, DepartmentMemberSummary } from './types';
import { getListResponse, API_BASE } from './utils';

export const memberKPITargetService = {
    list: async (params?: { period_id?: number; department_id?: number; member_id?: number }): Promise<MemberKPITarget[]> => {
        const response = await axios.get(`${API_BASE}/member-kpi-targets/`, { params });
        return getListResponse(response.data);
    },

    batchUpdate: async (periodId: number, memberId: number, targets: any[]): Promise<{ message: string; data: MemberKPITarget[] }> => {
        const response = await axios.post(`${API_BASE}/member-kpi-targets/batch_update/`, {
            period_id: periodId,
            member_id: memberId,
            targets,
        });
        return response.data;
    },
};

export const memberPerformanceRecordService = {
    list: async (params?: { period_id?: number; member_id?: number; department_id?: number }): Promise<MemberPerformanceRecord[]> => {
        const response = await axios.get(`${API_BASE}/member-performance-records/`, { params });
        return getListResponse(response.data);
    },

    batchRecord: async (periodId: number, memberId: number, records: { dimension_id: number; actual_value: number }[]): Promise<{ message: string; data: MemberPerformanceRecord[] }> => {
        const response = await axios.post(`${API_BASE}/member-performance-records/batch_record/`, {
            period_id: periodId,
            member_id: memberId,
            records,
        });
        return response.data;
    },

    getMemberSummary: async (periodId: number, memberId: number): Promise<MemberSummary> => {
        const response = await axios.get(`${API_BASE}/member-performance-records/member_summary/`, {
            params: { period_id: periodId, member_id: memberId },
        });
        return response.data;
    },

    getDepartmentSummary: async (periodId: number, departmentId: number): Promise<DepartmentMemberSummary> => {
        const response = await axios.get(`${API_BASE}/member-performance-records/department_summary/`, {
            params: { period_id: periodId, department_id: departmentId },
        });
        return response.data;
    },
};
